import { j as e } from "../../../../node_modules/react/jsx-runtime.js";
import { forwardRef as B, useState as S } from "react";
import { clsx as p } from "../../../../node_modules/clsx/dist/clsx.m.js";
import M from "../../Icon/Icon.js";
import _ from "./TextFieldMask.module.scss.js";
import { FieldLabel as G } from "../../TextField/components/FieldLabel/FieldLabel.js";
import J from "../../TextField/components/FieldHelperText/FieldHelperText.js";
import { i18n as Q } from "../../../../utils/locale/locale.js";
import U from "../../../../node_modules/@react-input/mask/dist/module/InputMask.js";
const V = B(
  ({
    label: a,
    optionalLabel: i,
    helperTextIcon: n,
    placeholder: c,
    value: d,
    type: K = "single",
    size: l = "regular",
    leadingIcon: x,
    width: F,
    trailingIcon: f,
    labelIconTooltip: u,
    helperText: j = "",
    disabled: t = !1,
    onChange: s,
    showClearIcon: h = !0,
    testId: D,
    onfocus: N,
    status: v,
    // hasTimePicker,
    id: w,
    autoComplete: E = "off",
    onClickLeadingIcon: m,
    onClickTrailingIcon: o,
    onArrowClick: y,
    ...R
  }, g) => {
    const [H] = S(() => "text_field_" + Math.random().toFixed(5).slice(2)), $ = w || H, O = document.body.getAttribute("dir") === "rtl", q = (r) => {
      s == null || s(r.target.value);
    };
    return /* @__PURE__ */ e.jsxs(
      W,
      {
        size: l,
        disabled: t,
        children: [
          a && /* @__PURE__ */ e.jsx(
            G,
            {
              label: a,
              optionalLabel: i,
              disabled: t,
              tooltipText: u,
              size: l,
              htmlFor: $,
              withTextField: !0
            }
          ),
          /* @__PURE__ */ e.jsxs(
            "div",
            {
              className: p(_.textField, _[l]),
              "aria-disabled": t,
              style: { width: F ?? "100%" },
              "data-destructive": v === "destructive",
              children: [
                x && /* @__PURE__ */ e.jsx(
                  "div",
                  {
                    "aria-disabled": t,
                    onClick: t ? void 0 : m,
                    className: p(_.leadingIcon, {
                      "cursor-pointer ": !t,
                      "pointer-events-none": t
                    }),
                    role: "button",
                    tabIndex: 0,
                    onKeyDown: (r) => {
                      r.key === "Enter" && (r.preventDefault(), m == null || m());
                    },
                    children: /* @__PURE__ */ e.jsx(M, { name: x })
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  "input",
                  {
                    ...R,
                    ref: g,
                    id: $,
                    placeholder: c || Q("select_date"),
                    value: d,
                    onChange: q,
                    onFocus: N,
                    disabled: t,
                    "data-testid": D,
                    autoComplete: E
                  }
                ),
                f && h && d && /* @__PURE__ */ e.jsx(
                  "div",
                  {
                    "aria-disabled": t,
                    onClick: t ? void 0 : o,
                    className: p(
                      _.trailingIcon,
                      o && "cursor-pointer",
                      {
                        "pointer-events-none": t
                      }
                    ),
                    role: "button",
                    tabIndex: 0,
                    onKeyDown: (r) => {
                      r.key === "Enter" && (r.preventDefault(), o == null || o());
                    },
                    children: d && /* @__PURE__ */ e.jsx(
                      M,
                      {
                        name: f,
                        style: { transform: O ? "rotate(180deg)" : "rotate(0deg)" }
                      }
                    )
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  "div",
                  {
                    "aria-disabled": t,
                    className: p(
                      {
                        "cursor-pointer": !t,
                        "cursor-not-allowed": t,
                        "pointer-events-none": t
                      },
                      _.trailingIcon
                    ),
                    role: "button",
                    tabIndex: 0,
                    onClick: t ? void 0 : y,
                    onKeyDown: (r) => {
                      (r.key === "Enter" || r.key === " ") && (r.preventDefault(), y == null || y());
                    },
                    children: /* @__PURE__ */ e.jsx(
                      M,
                      {
                        name: "chevron-down",
                        className: _.svg,
                        style: {
                          transform: R.isDatePickerOpen ? "rotate(180deg)" : "rotate(0deg)"
                        }
                      }
                    )
                  }
                )
              ]
            }
          ),
          (j || n) && /* @__PURE__ */ e.jsx(
            J,
            {
              label: j,
              disabled: t,
              icon: n,
              status: v,
              withTextField: !0
            }
          )
        ]
      }
    );
  }
), W = ({
  disabled: a,
  size: i,
  children: n
}) => /* @__PURE__ */ e.jsx(
  "div",
  {
    className: p(
      _.fieldContainer,
      _[`container-${i}`],
      a && _.disabled
    ),
    children: n
  }
), k = ({
  label: a,
  helperTextIcon: i,
  value: n,
  type: c = "single",
  size: d = "regular",
  placeholder: K,
  leadingIcon: l = "calendar",
  trailingIcon: x = "delete-filled",
  helperText: F = "",
  disabled: f = !1,
  hasTimePicker: u,
  onChange: j,
  testId: t,
  onfocus: s,
  width: h,
  status: D,
  onClickTrailingIcon: N,
  onClickLeadingIcon: v,
  ...w
}) => {
  const [E, m] = S(`${u ? "__ ___,____-__:__" : "__ ___,____"}`);
  return /* @__PURE__ */ e.jsx(
    U,
    {
      component: V,
      mask: E,
      replacement: "_",
      width: h,
      label: a,
      ...w,
      placeholder: K,
      value: n,
      size: d,
      disabled: f,
      testId: t,
      onClickLeadingIcon: v,
      onClickTrailingIcon: N,
      leadingIcon: l,
      trailingIcon: x,
      helperText: F,
      status: D,
      helperTextIcon: i,
      onChange: j,
      onfocus: (o) => {
        m(
          c === "single" ? `${u ? "__/__/____-__:__" : "__/__/____"}` : "__/__/____ - __/__/____"
        ), s == null || s(o);
      }
    }
  );
};
export {
  W as FieldContainer,
  k as default
};
//# sourceMappingURL=TextFieldMask.js.map
